__turbopack_context__.v({
  "actions": "mblbnner-module__vP3Zkq__actions",
  "bannerImg": "mblbnner-module__vP3Zkq__bannerImg",
  "bannerImgMobile": "mblbnner-module__vP3Zkq__bannerImgMobile",
  "contentCol": "mblbnner-module__vP3Zkq__contentCol",
  "contentWrapper": "mblbnner-module__vP3Zkq__contentWrapper",
  "desc": "mblbnner-module__vP3Zkq__desc",
  "icon": "mblbnner-module__vP3Zkq__icon",
  "imageColDesktop": "mblbnner-module__vP3Zkq__imageColDesktop",
  "imageColMobile": "mblbnner-module__vP3Zkq__imageColMobile",
  "layout": "mblbnner-module__vP3Zkq__layout",
  "panel": "mblbnner-module__vP3Zkq__panel",
  "section": "mblbnner-module__vP3Zkq__section",
  "stepdesc": "mblbnner-module__vP3Zkq__stepdesc",
  "storeBadge": "mblbnner-module__vP3Zkq__storeBadge",
  "storeBadgeEyebrow": "mblbnner-module__vP3Zkq__storeBadgeEyebrow",
  "storeBadgeEyebrowLight": "mblbnner-module__vP3Zkq__storeBadgeEyebrowLight",
  "storeBadgeIcon": "mblbnner-module__vP3Zkq__storeBadgeIcon",
  "storeBadgeLight": "mblbnner-module__vP3Zkq__storeBadgeLight",
  "storeBadgeText": "mblbnner-module__vP3Zkq__storeBadgeText",
  "storeBadgeTitle": "mblbnner-module__vP3Zkq__storeBadgeTitle",
  "storeBadgeTitleLight": "mblbnner-module__vP3Zkq__storeBadgeTitleLight",
  "title": "mblbnner-module__vP3Zkq__title",
});
